import { i18n } from '@/plugins/vue-i18n'

export function getOldRolesAsText(oldRoles) {
  if (oldRoles === null || oldRoles === undefined || oldRoles.length === 0) return ""

  let strBuilder = ""

  if (oldRoles.length > 0) {
    strBuilder = strBuilder.concat(` (${i18n.t('common.former')} `)

    for(let i = 0; i < oldRoles.length; i++) {
      const or = oldRoles[i]

      strBuilder = strBuilder.concat(i18n.t(`roles.CONST_${or}`))
      if (i + 1 < oldRoles.length) strBuilder = strBuilder.concat(", ")
    }

    strBuilder = strBuilder.concat(")")
  }
  

  return strBuilder
}